var _rect, _path, _path2, _path3, _circle, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedcart({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 78,
    viewBox: "0 0 83 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    y: 9.17676,
    width: 68.8235,
    height: 68.8235,
    rx: 14,
    fill: "url(#paint0_linear_69_21)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.257 59.0785C31.9199 59.0785 33.268 57.7304 33.268 56.0676C33.268 54.4047 31.9199 53.0566 30.257 53.0566C28.5941 53.0566 27.2461 54.4047 27.2461 56.0676C27.2461 57.7304 28.5941 59.0785 30.257 59.0785Z",
    stroke: "#E93A3A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3752 59.0785C45.0381 59.0785 46.3861 57.7304 46.3861 56.0676C46.3861 54.4047 45.0381 53.0566 43.3752 53.0566C41.7123 53.0566 40.3643 54.4047 40.3643 56.0676C40.3643 57.7304 41.7123 59.0785 43.3752 59.0785Z",
    stroke: "#E93A3A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2772 32.1826L26.8351 43.4474C27.3821 45.1785 27.6547 46.0441 28.1804 46.6849C28.6406 47.2513 29.2407 47.6885 29.9186 47.9593C30.6886 48.2656 31.5949 48.2656 33.411 48.2656H40.2348C42.0509 48.2656 42.9572 48.2656 43.7254 47.9593C44.4051 47.6885 45.0034 47.2513 45.4654 46.6849C45.9894 46.0441 46.2619 45.1785 46.8107 43.4474L47.5346 41.1534L47.9595 39.7975L48.5454 37.9389C48.7545 37.276 48.8044 36.5732 48.6913 35.8874C48.5781 35.2015 48.305 34.552 47.894 33.9915C47.4831 33.4309 46.9458 32.975 46.3258 32.6607C45.7059 32.3464 45.0206 32.1826 44.3255 32.1826H23.2772ZM23.2772 32.1826L23.2578 32.1171C23.183 31.8667 23.1004 31.6188 23.0099 31.3737C22.6516 30.4666 22.0439 29.6794 21.2571 29.103C20.4702 28.5267 19.5364 28.1848 18.5635 28.1167C18.3811 28.1025 18.1811 28.1025 17.7793 28.1025",
    stroke: "#E93A3A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 67.6764,
    cy: 14.9118,
    r: 14.9118,
    fill: "#E93A3A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5293 8.41171C66.5293 8.10749 66.6501 7.81573 66.8653 7.60061C67.0804 7.3855 67.3721 7.26465 67.6764 7.26465C67.9806 7.26465 68.2723 7.3855 68.4874 7.60061C68.7026 7.81573 68.8234 8.10749 68.8234 8.41171V17.5882C68.8234 17.8924 68.7026 18.1842 68.4874 18.3993C68.2723 18.6144 67.9806 18.7352 67.6764 18.7352C67.3721 18.7352 67.0804 18.6144 66.8653 18.3993C66.6501 18.1842 66.5293 17.8924 66.5293 17.5882V8.41171ZM66.5293 21.4117C66.5293 21.1075 66.6501 20.8157 66.8653 20.6006C67.0804 20.3855 67.3721 20.2646 67.6764 20.2646C67.9806 20.2646 68.2723 20.3855 68.4874 20.6006C68.7026 20.8157 68.8234 21.1075 68.8234 21.4117C68.8234 21.7159 68.7026 22.0077 68.4874 22.2228C68.2723 22.4379 67.9806 22.5588 67.6764 22.5588C67.3721 22.5588 67.0804 22.4379 66.8653 22.2228C66.6501 22.0077 66.5293 21.7159 66.5293 21.4117Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_69_21",
    x1: 34.4118,
    y1: 9.17676,
    x2: 34.4118,
    y2: 78.0003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E93A3A",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedcart);
export default __webpack_public_path__ + "static/media/redcart.c971f9e2b3d80d6b62eab6450b36a8d4.svg";
export { ForwardRef as ReactComponent };